import axios from 'axios';

const API_URL = '/api/business';

// Configure axios to send credentials with requests
axios.defaults.withCredentials = true;

const businessService = {
  /**
   * Save a single business data field
   */
  async saveField(fieldName, fieldValue) {
    try {
      const response = await axios.post(`${API_URL}/field`, {
        field_name: fieldName,
        field_value: fieldValue
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to save field'
      };
    }
  },

  /**
   * Save multiple business data fields
   */
  async saveFields(fields) {
    try {
      const response = await axios.post(`${API_URL}/fields`, {
        fields
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to save fields'
      };
    }
  },

  /**
   * Get a single business data field
   */
  async getField(fieldName) {
    try {
      const response = await axios.get(`${API_URL}/field/${fieldName}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to get field'
      };
    }
  },

  /**
   * Get all business data fields
   */
  async getAllFields() {
    try {
      const response = await axios.get(`${API_URL}/fields`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to get fields'
      };
    }
  },

  /**
   * Get specific business data fields by names
   */
  async getFieldsByNames(fieldNames) {
    try {
      const response = await axios.post(`${API_URL}/fields/by-names`, {
        field_names: fieldNames
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to get fields'
      };
    }
  },

  /**
   * Get all business basics fields
   */
  async getBusinessBasics() {
    try {
      const response = await axios.get(`${API_URL}/business-basics`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to get business basics'
      };
    }
  },

  /**
   * Save all business basics fields
   */
  async saveBusinessBasics(businessData) {
    try {
      const response = await axios.post(`${API_URL}/business-basics`, businessData);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to save business basics'
      };
    }
  },

  /**
   * Check if user has completed business basics
   */
  async checkBusinessBasicsStatus() {
    try {
      const response = await axios.get(`${API_URL}/status/business-basics`);
      return { success: true, completed: response.data.completed };
    } catch (error) {
      return {
        success: false,
        completed: false,
        error: error.response?.data?.error || 'Failed to check status'
      };
    }
  }
};

export default businessService;
